import { logoutFun } from "../../utils/helper";

const ApprovalPendingModal = ({ open, onAcknowledge }) => {
  if (!open) return null;

  const handleOk = () => {
    if (onAcknowledge) {
      onAcknowledge();
    } else {
      logoutFun();
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        padding: 16,
      }}
    >
      <div
        style={{
          background: "#ffffff",
          borderRadius: 14,
          maxWidth: 420,
          width: "100%",
          padding: "28px 28px 24px",
          boxShadow: "0 25px 60px rgba(0,0,0,0.35)",
          textAlign: "center",
          fontFamily: "inherit",
        }}
      >
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            background: "rgba(254,186,6,0.12)",
            border: "2px solid #FEBA06",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 18px",
          }}
        >
          <svg width="28" height="28" fill="none" stroke="#FEBA06" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4l3 2m6-2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        <div
          style={{
            fontSize: 20,
            fontWeight: 800,
            color: "#111827",
            marginBottom: 10,
            letterSpacing: "-0.02em",
          }}
        >
          Approval Pending
        </div>

        <p
          style={{
            fontSize: 13,
            color: "#4b5563",
            lineHeight: 1.6,
            marginBottom: 24,
          }}
        >
          Your account is awaiting admin approval. You'll be able to sign in and continue
          once an administrator has reviewed and approved your request.
        </p>

        <button
          type="button"
          onClick={handleOk}
          style={{
            width: "100%",
            background: "#FEBA06",
            color: "#161412",
            fontWeight: 800,
            fontSize: 13,
            padding: "12px 0",
            borderRadius: 8,
            border: "none",
            cursor: "pointer",
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            fontFamily: "inherit",
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default ApprovalPendingModal;
